import { useState, useRef, useEffect } from 'react';

export function useSafeSticky(topOffset = 0) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [top, setTop] = useState(topOffset);
  const lastScrollY = useRef(0);
  const currentTop = useRef(topOffset);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    lastScrollY.current = window.scrollY;

    function onScroll() {
      if (!ref.current) return;

      const el = ref.current;

      const { scrollY } = window;
      const deltaY = scrollY - lastScrollY.current;

      const minTop = el.clientHeight - window.innerHeight;

      currentTop.current = Math.min(Math.max(currentTop.current - deltaY, -minTop), topOffset);

      setTop(Math.round(currentTop.current));
      lastScrollY.current = scrollY;
    }

    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [topOffset]);

  return { ref, top };
}
